import { CREATE_UTILISATEUR_FAILURE, CREATE_UTILISATEUR_REQUEST, CREATE_UTILISATEUR_SUCCESS } from "../Types";

const initialState = {
    loading: false,
    error: null,
    utilisateur: null,
};

const CreateUtilisateursReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_UTILISATEUR_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_UTILISATEUR_SUCCESS:
            return { ...state, loading: false, utilisateur: action.payload };
        case CREATE_UTILISATEUR_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default CreateUtilisateursReducer;
